<template>
  <!-- Implementa un componente che mostra una modale per il caricamento di un file
       da allegare alla pratica con le relative info accessorie, all'ok sulla modale
       il file viene uploadato e al componente padre vengono restituite le info necessarie
       per associare poi il file all'acquisto. -->
  <div>
    <!-- BOTTONI VISUALIZZATI CON LA MODALE CHIUSA -->
    <!-- Bottoni per la visualizzazione/chiusura della modale -->
    <b-button v-if="show_remove_btn" variant="danger" class="mt-2" @click="rimuovi_file" >{{remove_button_text}}</b-button>
    <b-button v-else variant="info" class="mt-2" @click="visualizza_modale" >{{add_button_text}}</b-button>

    <!-- Diciture da porre sotto ai bottoni, riportano i nomi dei files caricati ed altre info -->
    <p v-if="doc_name" class="mt-2 mb-0"><b-icon icon="upload"></b-icon>  Hai caricato: <b>{{doc_name}}</b></p>
    <p v-if="doc_name != null && form.file_data != null && form.file_data.length > 1"><small><i>N.B. I files caricati saranno uniti insieme in un unico "pdf" e rinominati automaticamente dal sistema</i></small></p>

    <!-- MODALE DI CARICAMENTO DEI FILES -->
    <b-modal ref="file-modal" centered no-close-on-backdrop no-close-on-esc hide-header-close
        :cancel-disabled="this.disable_cancel_bnt" :ok-disabled="this.disable_ok_btn"
        :title="modal_title" @show="on_modal_show" @ok="upload_file" >

        <!-- Overlay di caricamento -->
        <CustomOverlay :show="overlay_show" text="Caricamento file...">

          <!-- SELECT SE LA TIPOLOGIA DI FILE GIA' ESISTE VISUALIZZATA SE IL BACKEND -->
          <!-- RILEVA FILES DELLO STESSO TIPO GIA' CARICATI IN PRECEDENZA -->
          <b-row v-if="show_existent_file_select">
            <b-col>
              <p class="text-justify"><u>Hai già caricato in precedenza documenti di questo tipo.</u> Verifica ed eventualmente
                scegli dalla lista quello di tuo interesse per allegarlo nuovamente a questa pratica.</p>
              <p> Se hai dubbi su quale documento selezionare puoi verificarne il contenuto nella sezione
                <b-link :to="{ name : 'site-archivio-files' }"><b>"I Miei Files"</b></b-link>.</p>
              <b-form-group id="group-doc-esistente"
                label="Seleziona file già caricato:"
                label-for="doc_esistente"
              >
                <b-form-select id="doc_esistente"
                              :options="file_exist_opt"
                              v-model="file_exist_selected"
                              :state="file_exist_validation">
                </b-form-select>
              </b-form-group>
              <p>In alternativa procedi caricando un nuovo file dal tuo dispositivo:</p>
              <b-button variant="primary" size="sm" @click="use_new_file_upload = true">
                <b-icon icon="cloud-upload"></b-icon> Carica file dal dispositivo
              </b-button>
            </b-col>
          </b-row>

          <!-- FORM PER CARICAMENTO FILE DAL DISPOSITIVO -->
          <!-- Tipo documento-->
          <b-row v-else>
            <b-col>
              <b-form-group id="group-doc-tipo"
                :label="'* Tipo documento:'"
                label-for="doc_tipo"
              >
                <b-form-select id="doc_tipo" v-model="form.file_kind_id"
                              :options="file_type_opt" :state="form_validation.file_kind_id" required></b-form-select>
              </b-form-group>

              <!-- Data del documento -->
              <b-form-group id="group-scad-doc"
                :label="doc_date_text"
                label-for="scad_doc">
                <b-form-datepicker
                    id="scad_doc"
                    v-model="form.file_date" class="mb-2"
                    :start-weekday="timepicker_it.start_weekday"
                    v-bind="timepicker_it.labels"
                    :state="form_validation.file_date"
                    required
                    ></b-form-datepicker>
              </b-form-group>

              <!-- Numero del documento -->
              <b-form-group id="group-doc-num"
                :label="'Numero del documento:'"
                label-for="doc_num">
                <b-form-input
                  id="doc_num"
                  type="number"
                  v-model="form.file_num"
                ></b-form-input>
              </b-form-group>

              <!-- File da uploadare -->
              <b-form-group id="group-file"
              :label="'* Allega file ( max 3Mb ):'"
              label-for="file-preventivo"
              description="Possono essere selezionati sino ad un massimo di 4 files da 3Mb ciascuno"
              :invalidFeedback="user_feedback_text"
              :validFeedback="user_feedback_text">
              <b-form-file
                id="file"
                v-model="file_form_vmodel"
                :placeholder="'Scegli o trascina qui i files'"
                drop-placeholder="Rilascia qui il file"
                accept=".jpg, .png, .pdf"
                browse-text="Seleziona"
                :multiple="true"
                :state="form_validation.file_data"
                @input="on_file_load"
                required
                ></b-form-file>
              </b-form-group>
            </b-col>
          </b-row>
        </CustomOverlay>
    </b-modal>
  </div>
</template>


<script>
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'FileUploadModal',
  data () {
    return {
      timepicker_it : generalLib.timepicker_it,

      // Un flag che indica alla pressione del tasto ok quale modalità di caricamento
      // usare, se true viene utilizzato il caricamento per un nuovo file dal dispositivo,
      // se false viene utilizzata la modalità di caricamento per i file esistenti.
      // Viene inizializzato nello on_show della modale sulla base del numero di files
      // già caricati.
      use_new_file_upload : null,

      // Opzioni di scelta tra i files dello stesso tipo già presenti a sistema.
      file_exist_opt :  [
        { value: null, text: "Seleziona un file", disabled: true }
      ],

      // File già presente selezionato
      file_exist_selected : null,

      // Status della select per i files già presenti
      file_exist_validation : null,

      // Tipi di files presenti in relazione al kind di file impostato
      file_type_opt : [
        { value: null, text: "Seleziona un'opzione", disabled: true }
      ],

      // Disabilitazione pulsanti di ok e cancel
      disable_cancel_bnt : false,
      disable_ok_btn: false,

      // Visualizzazione dell'overlay di caricamento del file
      overlay_show : false,

      // Campi per visualizzare la correttezza o meno dei campi obbligatori
      form_validation : {
        file_kind_id: null,
        file_date : null,
        file_num : null,
        file_data : null
      },

      // Dati che vengono inviati al backend per caricare i file,
      // i files possono essere più di uno, in tal caso file_data
      // è un'array. Non lo possiamo settare all'array vuota perchè
      // il v-model di b-form-file se non ci sono file selezionati
      // lo riporta a null.
      form : {
        file_kind_id: null, // Id del kind nella doc_type
        file_date : null,   // Data del documento
        file_num : null,    // Numero del documento
        file_data : []    // File
      },

      // Numero massimo che un utente più uploadare insieme
      // i quali poi saranno uniti in un singolo documento.
      MAX_FILE_NUM : 4,

      // Variabile per ricevere i files caricati dal v-model
      // della b-form-file ed aggiungerli a quelli già scelti
      // in form.file_data. La funzione che trasferisce i files
      // da qui alla form.file_data è la on_file_load che risponde
      // all'evento on input.
      file_form_vmodel: null,

      // Testo per dare all'utente un feedback sullo stato di caricamento dei
      // files, la variabile usata è la stessa sia per il feedback in caso
      // di errore che in caso di procedura corretta.
      user_feedback_text : null,

      // Nome del documento/i caricato/i per visualizzalo a video
      doc_name : null,

      // Id del documento caricato, utile per la rimozione
      doc_id : null,

      // Flag che indica se mostrare il pulsante di rimozione del documento o quello di caricamento
      show_remove_btn : false

    }
  },
  computed: {
    /**
     * Flag per visualizzare la select di caricamento di files già presenti se:
     * - ci sono files dello stesso tipo già caricati.
     * - l'utente non ha scelto dic aricare un nuovo file tramite l'apposito pulsante
     *   ( flag use_new_file_upload a true )
     */
    show_existent_file_select : function () {
      if ( this.file_exist_opt.length > 1 &&  ! this.use_new_file_upload ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods : {
    /**
     * Apre la modale
     */
    visualizza_modale : function () {
      // file-modal è il valore dell'attributo ref della modale.
      this.$refs['file-modal'].show()
    },
    /**
     * Esegue le opportune inizializzazioni allo visualizzazione
     * della modale, soprattutto se era stata già aperta in precedenza.
     */
    on_modal_show : function () {
      // Reset campo form
      this.form.file_kind_id = null;
      this.form.file_date = null;
      this.form.file_num = null;
      this.form.file_data = [];

      // Reset stato validazioni ( posso usare un for essendo tutte a null )
      for ( let key in this.form_validation ) {
        this.form_validation [ key ] = null;
      }
      // Resetto anche il blocco dei pulsanti di ok e cancel
      this.disable_cancel_bnt = false;
      this.disable_ok_btn = false;

      // Resettiamo anche tutto quello che riguarda la
      // selezione di un file già esistente
      this.file_exist_selected = null;
      this.file_exist_validation = null;

      // Se non sono presenti file esistenti devo inizializzare il flag che
      // che indica di utilizzare il caricamento dei files dal dispositivo a true,
      // altrimenti devo porlo a false per usare il caricamento di files già
      // aggiunti un precedenza.
      // Usiamo 1 e non 0 nell'if perchè nelle opzioni c'è quella di default
      // "Seleziona un file".
      if ( this.file_exist_opt.length == 1 ) {
        this.use_new_file_upload = true;
      } else {
        this.use_new_file_upload = false;
      }

    },
    /**
     * Alla pressione del tasto OK verifica la modalità con la quale allegare
     * il file alla pratica ( se da dispositivo o esistente ) ed esegue la relativa
     * funzione.
     */
    upload_file : function ( bvModalEvt ) {

      bvModalEvt.preventDefault();

      if ( this.use_new_file_upload ) {
        this.upload_da_dispositivo();
      } else {
        this.upload_esistente();
      }

    },
    /**
     * Esegue l'upload di un file dal dispositivo.
     * Valida i campi alla pressione del campo ok, altrimenti segna in rosso i campi
     * obbligatori che sono:
     *  - Tipologia del documento
     *  - Data del documento
     *  - I files
     *
     * Emette infine l'evento fileDataReady per far sapere al parent che i dati sono stati
     * correttamente caricati nella modale.
     */
    upload_da_dispositivo : function () {

      this.form.file_kind_id === null ? this.form_validation.file_kind_id = false : this.form_validation.file_kind_id = true ;
      this.form.file_date === null ? this.form_validation.file_date = false : this.form_validation.file_date = true ;

      // Per i files la validazione viene gestita al momento della scelta dal filesystem tramite la funzione on_file_load,
      // ad ogni modo potrebbe accadere che l'utente prema il pulsante ok prima di aver caricato un qualsiasi file non eseguendo
      // quindi mai la funzione on_file_load e non eseguendo quindi una validazione, andiamo quindi a verificare se la
      // variabile di validazione è ancora a null, e se si non lo facciamo proseguire.
      if ( this.form_validation.file_data === null ){
        this.form_validation.file_data = false;
        this.user_feedback_text = 'Nessun file caricato.';
      }

      // Se tutti i campi obbligatori sono stati validati possiamo allora caricare il file,
      // chiudere la modale e passare i dati al componente padre
      if ( this.form_validation.file_kind_id && this.form_validation.file_date && this.form_validation.file_data ) {

        let form_data = this.prepara_dati_multipart();

        // Visualizziamo l'overlay di caricamento e disabilitiamo i pulsanti
        // di ok e cancel
        this.overlay_show = true;
        this.disable_cancel_bnt = true;
        this.disable_ok_btn = true;

        axios.post( apiUrl.documentsapi.upload_allegato ,
                    form_data,
                  {
                      headers: {
                          'Content-Type': 'multipart/form-data'
                      }
                  })
                  .then( (response) => {
                    // Tutto ok, tolgo l'overlay e chiudo la modale emetto poi l'evento
                    // fileDataready per il parent il quale gli dice che il file è stato
                    // caricato
                    this.overlay_show = false;

                    // Devo far vedere il pulsante di rimozione del documento
                    this.show_remove_btn = true;

                    // Al chiamandte torniamo l'id del documento caricato per fare in modo che possa poi essere
                    // associato all'acquisto, ed anche il kind del file, per poter distinguere se in un form ne
                    // andiamo ad usare più di una. Settiamo poi il nome del file da visualizzare a video , se più
                    // di uno creiamo la lista dei files caricati, ed il riferimento
                    // interno all'id del documento caricato da poter usare poi per la rimozione
                    this.doc_name = this.form.file_data.map( ( elem ) => elem.name ).join(', ');
                    this.doc_id = response.data.doc_id;
                    let event_data = { doc_id : response.data.doc_id, file_kind : this.file_kind };
                    this.$emit( 'fileIdReady', event_data );

                    // Chiudiamo infine la modale.
                    this.$nextTick(() => {
                      this.$refs['file-modal'].hide('modal-prevent-closing');
                    });

                  })
                  .catch( (error) => {
                    // Ko, tolgo l'overlay e riabilito i pulsanti
                    this.overlay_show = false;
                    this.disable_cancel_bnt = false;
                    this.disable_ok_btn = false;
                    generalLib.backend_error_message_box( this, error.response.data );
                  });

      }
    },
    /**
     * Funzione associata all'evento "input" del della b-form-file, se si opta per il caricamento
     * da dispositivo e non da file esistente.
     * Nel momento in cui viene caricato un file dal dispositivo viene eseguita questa funzione,
     * la quale prende tutti i files caricati in file_form_vmodel e li traferisce nella varibile
     * interna form.file_data.
     * In questo modo il sistema può ricordare i files caricati in precedenza.
     * La variabile del v-model viene poi resettata.
     */
    on_file_load : function () {

      if ( this.file_form_vmodel === null ||
          ( this.file_form_vmodel !== null && this.file_form_vmodel.length == 0 ) ) return;

      // Mentre trasferisco i files nell'array definitiva faccio un controllo di validità sulla dimensione.
      let size_ok = true;
      this.file_form_vmodel.forEach( ( element ) => {
        if ( element.size > 3145728 ) size_ok = false;
        this.form.file_data.push( element );
      });

      // Resetto il form model, lavorando in modalità multifile devo mettere un'array vuota per ressettarlo e non null
      this.file_form_vmodel = [];

      // Ora vado a vedere tutti i possibili errori e setto la variabile di validazione,
      // se il controllo di validatione fallisce resetto anche l'array dei files già caricati
      if ( !size_ok ) {
        this.form_validation.file_data = false;
        this.user_feedback_text = 'Sono stati caricati files che superano la dimensione massima di 3 Mb. Selezione annullata, controllare e riprovare.'
        this.form.file_data = [];
      } else if ( this.form.file_data.length == 0 ){
        this.form_validation.file_data = false;
        this.user_feedback_text = 'Nessun file caricato.';
      } else if ( this.form.file_data.length > this.MAX_FILE_NUM  ) {
        this.form_validation.file_data = false;
        this.user_feedback_text = 'Caricati ' + this.form.file_data.length + ' file, è possible caricare un massimo di ' + this.MAX_FILE_NUM + ' file.  Selezione annullata, controllare e riprovare.'
        this.form.file_data = [];
      } else {
        this.form_validation.file_data = true;
        let file_names = this.form.file_data.map( ( elem ) => elem.name ).join(', ');
        this.user_feedback_text = 'Caricati ' + this.form.file_data.length + ' file: ' + file_names;
      }

    },
    /**
     * Esegue l'associazionde di una pratica con un documento già esistente che viene clonato
     * lato backend.
     *
     * Prima di procedere controlla che sia stato effettivamente selezionato un file.
     *
     * Emette infine l'evento fileDataReady per far sapere al parent che i dati sono stati
     * correttamente caricati nella modale.
     */
    upload_esistente : function () {

      this.file_exist_selected === null ? this.file_exist_validation = false : this.file_exist_validation = true;

      if ( this.file_exist_validation ) {

        // Visualizziamo l'overlay di caricamento e disabilitiamo i pulsanti
        // di ok e cancel
        this.overlay_show = true;
        this.disable_cancel_bnt = true;
        this.disable_ok_btn = true;

        let data_to_send = { id_documento : this.file_exist_selected.id };
        axios.post( apiUrl.documentsapi.clona_allegato_esistente, data_to_send  )
        .then( ( response ) => {
          // Tutto ok, tolgo l'overlay e chiudo la modale emetto poi l'evento
          // fileDataready per il parent il quale gli dice che il file è stato
          // caricato
          this.overlay_show = false;

          // Devo far vedere il pulsante di rimozione del documento
          this.show_remove_btn = true;

          // Al chiamante torniamo l'id del documento caricato per fare in modo che possa poi essere
          // associato all'acquisto, ed anche il kind del file, per poter distinguere se in un form ne
          // andiamo ad usare più di una. Settiamo poi il nome del file da visualizzare a video ( che posso
          // prendere dalla select stessa visto che è il medesimo file ) ed il riferimento
          // interno all'id del documento caricato da poter usare poi per la rimozione ( questa invece presa dal
          // ritorno della funzioen eprchè ora il file è stato clonato e qundi ha un altro id )
          this.doc_name = this.file_exist_selected.file_name;
          this.doc_id = response.data.doc_id;
          let event_data = { doc_id : response.data.doc_id, file_kind : this.file_kind };
          this.$emit( 'fileIdReady', event_data );

          // Chiudiamo infine la modale.
          this.$nextTick(() => {
            this.$refs['file-modal'].hide('modal-prevent-closing');
          });
        })
        .catch( ( error ) => {
          // Ko, tolgo l'overlay e riabilito i pulsanti, metto la validazione del
          // file come non valida
          this.overlay_show = false;
          this.disable_cancel_bnt = false;
          this.disable_ok_btn = false;
          this.file_exist_validation = false;
          generalLib.backend_error_message_box( this, error.response.data );
        });
      }

    },
    /**
     * Prepara i dati per essere inviati come multipart.
     * Usiamo multipart perchè così possiamo caricare i dati binary tramite
     * la classe FormData di javascript, cosa che non possiamo fare inviando
     * un semplice json.
     * I multipart come il form-data, non hanno come il json il concetto di
     * conversione dei null in None, ma si limitano a convertire il null nel
     * suo corrispettivo unicode 'null' facendo saltare la validazione lato Django.
     * Per questo i files che non sono stati caricati perchè opzionali, e quindi
     * indicati come null, sono convertiti in stringa vuota cosi che  Django Rest
     * nel serializzatore li riconverte in None, così siamo apposto!
     * ( https://stackoverflow.com/questions/30677216/django-rest-frameworks-apiclient-sends-none-as-none )
     */
    prepara_dati_multipart : function () {

      let form_data = new FormData();

      form_data.append( 'file_kind_id', this.form.file_kind_id === null ? '' : this.form.file_kind_id );
      form_data.append( 'file_date', this.form.file_date === null ? '' : this.form.file_date );
      form_data.append( 'file_num', this.form.file_num === null ? '' : this.form.file_num );

      // Per aggiungere i files come array di files al FormData
      // doppiamo usare append utilizzando per tutti la stessa
      // chiave.
      for ( let f of this.form.file_data ){
        form_data.append( 'file_data', f );
      }

      // Aggiungiamo anche il kind come riferimento, anche se
      // possiamo dedurlo tramite tabella dal file_kind_id
      form_data.append( 'file_kind', this.file_kind );

      return form_data;
    },
    /**
     * Rimuove il file caricato.
     */
    rimuovi_file : function () {
      // Eseguiamo la delete verso il backend per cancellare il file
      let api_url = apiUrl.documentsapi.delete_allegato.replace( '@doc_id', this.doc_id );
      axios.delete( api_url )
      .then( (response) => {

        // File cancellato, lo notifico al chiamante passandogli l'id del file rimosso
        // ed il kind del file, utile se in un form si usa più di una modale di upload.
        let event_data = { doc_id : this.doc_id, file_kind : this.file_kind };
        this.$emit( 'fileRemoved', event_data );

        // Poi posso resettare lo stato interno.
        // L'oggetto form viene invece resettato ad ogni apertura della
        // modale quindi non ve ne è bisogno.
        this.doc_id = null;
        this.doc_name = null;
        this.show_remove_btn = false;

      })
      .catch( (error) => {
        generalLib.backend_error_message_box( this, error.response.data );
      });
    }
  },
  created : function () {
    /**
     * Alla creazione dell'elemento andiamo a popolare le opzioni del tipo
     * di files con quelle relative al kind impostato.
     */
    let api_url = apiUrl.documentsapi.lista_doc_per_tipo.replace( '@kind', this.file_kind );
    axios.get( api_url )
      .then( ( response ) => {
          for ( let elem of response.data ) {

            // Se la tipologia di file è tra quelli da escludere dalle scelte possibili
            // allora passiamo oltre.
            if ( this.exclude_file_options.includes( elem.id ) ) continue;

            this.file_type_opt.push( { value : elem.id, text : elem.nome } );
          }
      })
      .catch( (error) => {
        console.error(error);
     })

     /**
      * Andiamo inoltre a popolare anche la select dei files già caricati per lo stesso
      * tipo, di modo tale che l'utente può scegliere se prendere un file già caricato o meno
      */
     let file_esistenti_url = apiUrl.documentsapi.get_file_esistenti.replace( '@kind', this.file_kind );
     axios.get( file_esistenti_url )
      .then( ( response ) => {

        // Rielaboriamo i dati per poter riempire la select come grouped options,
        // il valore della select lo impostiamo come un oggetto a sua volta, di
        // modo tale da poter avere nel v-model al momento della selezione, anche
        // il nome del file, che altrimenti sarebbe usato solo nella visualizzazione
        // della select. Ci serve per far vedere poi a video quale file è stato scelto.
        for ( let elem of response.data ) {

          // Se la tipologia di file è tra quelli da escludere dalla visualizzazione passiamo oltre
          if ( this.exclude_file_options.includes( elem.id_tipo ) ) continue;

          let file_list = []
          for ( let files of elem.files ) {
            file_list.push ( { 'value' : { 'id' : files.id, 'file_name' : files.file_name }, 'text' : files.file_name } );
          }
          this.file_exist_opt.push( { 'label' : elem.tipo, 'options' : file_list } );
        }

      })
      .catch( (error) => {
        console.error(error);
      })

  },
  props: {
    /**
     * Tipologia del file che andiamo a caricare
     */
    file_kind : {
      type: String,
      required: true
    },
    /**
     * Eventuali id delle tipologie di files da escludere dalla select.
     * Si tratta degli id della tabella "doc_tipo"
     */
    exclude_file_options : {
      type: Array,
      default : () => { return new Array(); }
    },
    /**
     * Stringa relativa alla data del documento
     */
    doc_date_text : {
      type: String,
      default : "* Data documento:"
    },
    /**
     * Stringa per il pulsante di aggiunta del file
     */
    add_button_text : {
      type: String,
      default : "Carica documentazione"
    },
    /**
     * Stringa per il pulsante di rimozione del file
     */
    remove_button_text : {
      type: String,
      default: "Rimuovi la documentazione"
    },
    /**
     * Titolo della modale
     */
    modal_title : {
      type: String,
      default : "Carica documento"
    }
  },
  components: {
    CustomOverlay
  }
}
</script>

<style scoped></style>